import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ModuleDetailsComponentEnum } from "src/app/shared/enums/module-details-component.enum";

@Injectable({
  providedIn: "root"
})
export class ModuleDetailsService {
  private moduleDetails: BehaviorSubject<ModuleDetailsComponentEnum> =
    new BehaviorSubject<ModuleDetailsComponentEnum>(null);

  public moduleDetails$: Observable<ModuleDetailsComponentEnum> =
    this.moduleDetails.asObservable();

  setModuleDetails(moduleDetails: ModuleDetailsComponentEnum) {
    this.moduleDetails.next(moduleDetails);
  }
}
